import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '$partials/media';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleType = ({
    title,
    typeItemsCollection,
    parent
}) => {
    const items = typeItemsCollection.items;

    return (
        <div className={`bg-white relative ${parent === 'Home' ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'}`}>
            <div className='layout-container'>
                <div className='bg-white -mx-10 sm:-mx-35 md:mx-0  md:px-10'>
                    <div
                        className='bg-sand rounded-button px-20 py-30 md:py-50 sm:px-35 md:px-0'>
                        {title &&
                            <div className='pb-30 sm:pb-20 sm:px-5 md:px-50'>
                                <h2 className='type-style-3'>{title}</h2>
                            </div>
                        }
                        <div className='w-full grid grid-cols-1 sm:grid-cols-3 sm:gap-x-0 gap-y-40 sm:max-md:gap-y-30 md:gap-x-20 md:px-50'>
                            {items.map((item, idx) => (
                                <div
                                    className='w-full flex flex-wrap sm:px-5 md:px-0'
                                    key={idx}>
                                    <div className='w-full sm:max-md:pb-20 pb-40 border-b border-dark-grey flex flex-wrap'>
                                        <div className='flex items-center sm:max-md:mb-15 mb-25 w-full'>
                                            {item.icon && (
                                                <div
                                                    style={{
                                                        fontSize: '48px',
                                                        width: `${(item.icon?.width / item.icon?.height)}em` ,
                                                        maxWidth: '100%'
                                                    }}>
                                                    <Image
                                                        {...item.icon}
                                                        loading={''}/>
                                                </div>
                                            )}
                                        </div>
                                        <p className='w-full type-style-4 pb-5'>{item.title}</p>
                                        <p className='w-11/12 type-style-5 text-light-grey'>{item.body}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModuleType.propTypes = {
    typeItemsCollection: PropTypes.object,
    title: PropTypes.string,
    parent: PropTypes.string,
};

export default ModuleType;
